export default __webpack_public_path__ + "static/04_Rabbit-32f96db08579141907509bb92eed8163.png";